import 'core-js';
import 'regenerator-runtime/runtime';
import 'bootstrap/dist/css/bootstrap.css';
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import store from './store/store';
import * as AppTokenUtil from './util/AppTokenUtil';
import App from './App';
import Loading from './components/misc/Loading';

import './i18n';

AppTokenUtil.handleAuthWindow();

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

history.listen(location => {
    setTimeout(() => {
        if (location.action === 'POP') {
            return;
        }
        window.scrollTo(0, 0);
    });
});

const root = createRoot(document.getElementById('root'));

root.render(
    <Suspense fallback={ <Loading /> }>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </Suspense>
);

